import { Controller } from "stimulus"
import { Carousel } from "bootstrap"

export default class extends Controller {
  static targets = ['animation','slideshow']

  initialize() {
    this.carousel = new Carousel(this.slideshowTarget, { interval: 4000, ride: 'carousel', pause: false })
    this.carousel.cycle()
  }

  connect() {
    if (!document.cookie.match('intro=false')) {
      this.carousel.pause()
      this.animationTarget.classList.replace('d-none','run')
      this.animationTarget.addEventListener("animationend", this.animationEnd, false)
    }
  }

  animationEnd(event) {
    let animation = event.currentTarget
    if (animation.classList.contains('run')) {
      setTimeout(()=>{
        animation.classList.replace('run','hide')
      }, 4000)
    } else {
      animation.classList.replace('hide','d-none')
      // this.carousel ist da leider nicht verfügbar...
      let carousel_element = document.getElementById('carousel')
      let carousel = Carousel.getInstance(carousel_element)
      carousel.cycle()

      // set cookie
      let expiration_date = new Date()
      let cookie_string = ''
      expiration_date.setFullYear(expiration_date.getFullYear() + 1)
      cookie_string = "intro=false; path=/; expires=" + expiration_date.toUTCString()
      document.cookie = cookie_string
    }
  }
}
